import { defaults } from "lodash";
import type { FormMetadataParams } from "@searchui-searchforms/shared/schemas";

export const formMetadataQueryKeys = {
    all: ["formMetadata"] as const,
    detail: ({ formType, ...otherParams }: FormMetadataParams) => {
        const otherParamsWithDefaults = defaults(otherParams, {
            debug: false,
        });

        return ["formMetadata", formType, otherParamsWithDefaults] as const;
    },
};
